import React from 'react'
import styled from 'styled-components'

const Document = styled.img`
    display: none;
    height: 70px;
    width: fit-content;
    background-color: #000;
    border-radius: 10px;
    &:hover{
        cursor: pointer;
        opacity: 0.8;
    }
`

const Description = styled.div`
    width: 100%;
    font-size: 15px;
    font-weight: 400;
    color: ${({ theme }) => theme.text_secondary};
    line-height: 1.6;
    margin-bottom: 10px;
    @media only screen and (max-width: 768px){
        font-size: 13px;
    }
`

const Span = styled.span`
    overflow: hidden;
    display: -webkit-box;
    max-width: 100%;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
`

const Card = styled.div`
    width: 650px;
    background-color: ${({ theme }) => theme.card};
    border-radius: 16px;
    box-shadow: 0px 4px 20px rgba(0,0,0,0.3);
    border: 1px solid rgba(255, 255, 255, 0.05);
    padding: 24px 28px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    transition: all 0.3s ease-in-out;
    position: relative;
    overflow: hidden;
    
    &:hover{
        box-shadow: 0px 10px 30px rgba(0,0,0,0.4);
        transform: translateY(-5px);
        border: 1px solid ${({ theme }) => theme.primary}50;
    }
    
    @media only screen and (max-width: 768px){
        padding: 16px;
        gap: 12px;
        width: 320px;
    }

    &:hover ${Document}{
        display: flex;
    }

    &:hover ${Span}{
        overflow: visible;
        -webkit-line-clamp: unset;
    }
`

const Top = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
    @media only screen and (max-width: 768px){
        gap: 16px;
    }
`

const Image = styled.img`
    height: 65px;
    width: 65px;
    object-fit: contain;
    background-color: #ffffff;
    border-radius: 12px;
    padding: 6px;
    box-shadow: 0px 2px 10px rgba(0,0,0,0.1);
    border: 1px solid rgba(0,0,0,0.05);
    flex-shrink: 0;
    
    @media only screen and (max-width: 768px){
        height: 50px;
        width: 50px;
        padding: 4px;
    }
`

const Body = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
`

const Role = styled.div`
    font-size: 20px;
    font-weight: 700;
    line-height: 1.2;
    color: ${({ theme }) => theme.text_primary};
    margin-bottom: 4px;
    @media only screen and (max-width: 768px){
        font-size: 16px;
    }
`

const Company = styled.div`
    font-size: 15px;
    font-weight: 500;
    color: ${({ theme }) => theme.text_secondary};
    @media only screen and (max-width: 768px){
        font-size: 13px;
    }
`

const Date = styled.div`
    font-size: 13px;
    font-weight: 400;
    color: ${({ theme }) => theme.primary};
    margin-top: 4px;
    @media only screen and (max-width: 768px){
        font-size: 11px;
    }
`


const Skills = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
    margin-top: 8px;
    color: ${({ theme }) => theme.text_primary};
`

const ItemWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
`

const Skill = styled.div`
    font-size: 14px;
    font-weight: 500;
    color: ${({ theme }) => theme.primary};
    background-color: ${({ theme }) => theme.primary + 15};
    padding: 4px 10px;
    border-radius: 8px;
    @media only screen and (max-width: 768px){
        font-size: 12px;
    }
`



const ExperienceCard = ({ experience }) => {
    return (
        <Card>
            <Top>
                <Image src={experience.img} alt={experience.company || experience.organization} />
                <Body>
                    <Role>{experience.role}</Role>
                    <Company>{experience.company || experience.organization}</Company>
                    <Date>{experience.date}</Date>
                </Body>
            </Top>
            <Description>
                {experience?.desc &&
                    <Span>{experience?.desc}</Span>
                }
                {experience?.skills &&
                    <Skills>
                        <b>Skills:</b>
                        <ItemWrapper>
                            {experience?.skills?.map((skill, index) => (
                                <Skill key={index}>{skill}</Skill>
                            ))}
                        </ItemWrapper>
                    </Skills>
                }
            </Description>
            {experience.doc &&
                <a href={experience.doc} target="new">
                    <Document src={experience.doc} />
                </a>
            }
        </Card>
    )
}

export default ExperienceCard